class Point {
    X_axis:number;
    Y_axis:number;

    constructor(x_axis:number,y_axis:number){
        this.X_axis=x_axis;
        this.Y_axis=y_axis
    }
  }

  export default Point